import { DataGridBody, DataGridCell, DataGridRow } from '@twilio-paste/core/data-grid';

import { AppModel } from '../../../modules/Apps';

import { ScopesTableActions } from './ScopesTableActions';

interface ScopesTableBodyProps {
  app: AppModel;
}

export function ScopesTableBody({ app }: ScopesTableBodyProps) {
  const { scopes } = app;

  return (
    <DataGridBody>
      {scopes?.map(scope => (
        <DataGridRow key={scope.scopeId}>
          <DataGridCell>{scope.name}</DataGridCell>
          <DataGridCell>{scope.keyword}</DataGridCell>
          <DataGridCell>{scope.scopeId}</DataGridCell>
          <DataGridCell>{app.name}</DataGridCell>
          <DataGridCell textAlign="center">
            <ScopesTableActions scope={scope} />
          </DataGridCell>
        </DataGridRow>
      ))}
    </DataGridBody>
  );
}
